import { AlertTriangle } from 'lucide-react';
import { useActiveClinic } from '@/lib/ActiveClinicContext';

/**
 * Warning banner shown when a main clinic admin is viewing an inactive sub-clinic.
 * Regular users cannot access inactive sub-clinics (filtered by JWT), but main
 * clinic admins can still view them for management/reactivation purposes.
 */
export function InactiveClinicBanner() {
  const { activeClinic, isMainClinicAdmin } = useActiveClinic();
  
  // Only show for main clinic admins viewing inactive sub-clinics
  if (!isMainClinicAdmin || !activeClinic?.isSubClinic || activeClinic.isActive !== false) {
    return null;
  }
  
  return (
    <div className="bg-orange-50 dark:bg-orange-900/30 border-b border-orange-200 dark:border-orange-800 px-6 py-3">
      <div className="flex items-center gap-3 max-w-7xl mx-auto">
        <AlertTriangle className="h-5 w-5 text-orange-600 dark:text-orange-400 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-medium text-orange-900 dark:text-orange-200">
            This sub-clinic is currently inactive
          </p>
          <p className="text-xs text-orange-700 dark:text-orange-300 mt-0.5">
            Regular users and employees cannot access this clinic. Only main clinic admins can view it.
          </p>
        </div>
      </div>
    </div>
  );
}
